import { randEmail } from '@ngneat/falso';
import { IntegrationType } from '@principle-theorem/integrations';
import {
  CommunicationDirection,
  EmailActionType,
  EmailDeliveryStatus,
  EmailMessage,
  EmailResourceType,
  IAutomatedNotification,
  IAutomation,
  IContactEmailContactDetails,
  IEmailReplyTokenData,
  IPractice,
} from '@principle-theorem/principle-core/interfaces';
import { BaseFirestoreMock, Properties } from '@principle-theorem/shared';
import { MockDocRef } from '@principle-theorem/testing';

export class EmailMessageMock
  extends BaseFirestoreMock<Properties<EmailMessage>>
  implements Properties<EmailMessage>
{
  readBy = [];
  subject = 'Test Subject';
  text = 'Test Text';
  html = '<p>Test HTML</p>';
  recipientEmail = randEmail();
  recipientRef = MockDocRef<IContactEmailContactDetails>();
  practiceEmail = randEmail();
  practiceRef = MockDocRef<IPractice>();
  authorRef: IntegrationType.Sendgrid = IntegrationType.Sendgrid;
  automationRef = MockDocRef<IAutomation<IAutomatedNotification>>();
  direction = CommunicationDirection.Outbound;
  status = EmailDeliveryStatus.Sent;
  attachments = [];
  replyData = {
    uid: 'test-uid',
    practiceRef: MockDocRef<IPractice>(),
    actionType: EmailActionType.Reply,
    resourceType: EmailResourceType.Patient,
    resourceRef: MockDocRef<IContactEmailContactDetails>(),
  } as IEmailReplyTokenData;
  errorMessage = '';
}
